module.exports = __webpack_public_path__ + "static/media/solution1.2b14d712.png";